import { useRef, useState, useEffect } from "react";
import { getDropdownFormat } from "../../../views/pages/manage/edpOps/issuanceIDcard/customhooks";
import { getBatchList } from "../../../views/pages/manage/edpOps/issuanceIDcard/service";
import { removeKeysFromObject } from "../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const mapItemTypeToDescription = (list = []) => {
  return list.reduce((acc, item) => {
    acc[item.itemType] = item.description;
    return acc;
  }, {});
};

//console.log(mapItemTypeToDescription(result['TRANSFER_OUT']))

export const formatTransferInItems = (
  inTransferList = [],
  outTransferList = []
) => {
  const descriptionMap = mapItemTypeToDescription(outTransferList);
  return inTransferList.map((item) => ({
    ...item,
    description: descriptionMap[item.itemType],
    grossAmount: item.baseAmount,
    taxes: item.tax,
    concessionApplied:item?.concessionValue,
    payableAmount:item?.payable
  }));
};

export const formatTransferOutTax = (
  outTransferList = []
) => {
  return outTransferList.map((item) => ({
    ...item,
    taxes: item?.aesStCgst1 + item?.aesStIgst1 + item?.aesStUgst1
  }));
};

export function getStudentFromData(student) {
  return {
    term: {
      value: student.term,
      label: student.termDispVal,
    },
    businessArea: {
      value: student.businessArea,
      label: student.businessAreaDispVal,
    },
    courseId: {
      value: student.courseId,
      label: student?.courseId,
    },
    academicGroup: {
      value: student.academicGroup,
      label: student.academicGroupDispValue,
    },
    academicCareer: {
      value: student.academicCareer,
      label: student.academicCareerValue,
    },
  };
}

export const transferReasonDropdown = [
  { label: "APBM - Approved by Branch Manager", value: "APBM" },
  { label: "APRG - Approval from Registered office", value: "APRG" },
  { label: "AUDT - Audit Cases", value: "AUDT" },
  { label: "HLTH - Health issue", value: "HLTH" },
  { label: "HOST - Hostel Issue", value: "HOST" },
  { label: "PATR - Parents Transfer", value: "PATR" },
  { label: "RETN - To Retain the Student", value: "RETN" },
];

export const findByLabel = (value, dropdown = []) =>
  dropdown.find((item) => item['value'] === value);

export const createSearchBatchRequest = (studentDetails) => {
  return {
    term: [studentDetails?.term?.value],
    courseId: [studentDetails?.courseId?.value],
    academicGroup: studentDetails?.academicGroup?.value,
    academicCareer: studentDetails?.academicCareer?.value,
    businessArea: [studentDetails?.businessArea?.value],
  };
};

const areRequestsEqual = (prev, next) => {
  return (
    prev.term?.[0] === next.term?.[0] &&
    prev.courseId?.[0] === next.courseId?.[0] &&
    prev.academicGroup === next.academicGroup &&
    prev.academicCareer === next.academicCareer &&
    prev.businessArea?.[0] === next.businessArea?.[0]
  );
};

export const useGetBatchList = (request) => {
  const [batches, setBatches] = useState([]);
  const prevRequestRef = useRef({});

  useEffect(() => {
    const shouldFetch = !areRequestsEqual(prevRequestRef.current, request);

    if (shouldFetch && request?.businessArea?.[0] && request?.term?.[0]) {
      const fetchBatches = async () => {
        try {
          const response = await getBatchList(request);
          if (response?.code === 200) {
            //setBatches(getDropdownFormat(response.data.batchSearchResponseDTOList));

            setBatches(
              getDropdownFormat([
                {
                  id: 5471839,
                  batchName: "BR041-009-2024-105399",
                  batchCapacity: 10,
                  currentStrength: 0,
                  batchType: "SECONDARY",
                  batchEnrollmentStatus: "OPEN",
                  classType: "1",
                  batchStatus: "ACTIVE",
                  msTeamsGroupId: null,
                  msTeamsGroupSequence: null,
                  schoolBoard: "1",
                  medium: "1",
                  batchStartDate: "2025-06-10T18:30:00.000+00:00",
                  batchEndDate: "2025-06-29T18:30:00.000+00:00",
                  timeTableStatus: "U",
                },
                {
                  id: 5471839,
                  batchName: "BR041-009-2024-1053",
                  batchCapacity: 10,
                  currentStrength: 0,
                  batchType: "SECONDARY",
                  batchEnrollmentStatus: "OPEN",
                  classType: "1",
                  batchStatus: "ACTIVE",
                  msTeamsGroupId: null,
                  msTeamsGroupSequence: null,
                  schoolBoard: "1",
                  medium: "1",
                  batchStartDate: "2025-06-10T18:30:00.000+00:00",
                  batchEndDate: "2025-06-29T18:30:00.000+00:00",
                  timeTableStatus: "U",
                },
              ])
            );
          } else {
            setBatches([]);
          }
        } catch (error) {
          console.error("Batch list fetch failed", error);
        } finally {
          prevRequestRef.current = request;
        }
      };

      fetchBatches();
    }
  }, [request]);

  return batches;
};

export const inputHeight = { height: "44px", color: "#AFAFAF" };

export const getBulkOnlyFilters = filterObj => removeKeysFromObject(filterObj, ["psid", "applicationId", "studentName"]);
